import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { hlm } from 'app/core/utils/hlm';
import { ClassValue } from 'clsx';

@Component({
  selector: 'sheba-shevron-start-icon',
  templateUrl: 'shevron-start.svg',
  host: {
    '[class]': 'computedClass()'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShevronStartIcon {
  readonly userClass = input<ClassValue>('', { alias: 'class' });
  readonly computedClass = computed(() => hlm('block ltr:rotate-180 [[end]>&]:-scale-x-100', this.userClass()));
}
